/**
 * Generate a weekly word count message
 * @param {number} wordCount - Total word count for the week
 * @returns {string} - Formatted message (e.g., "You've written 12,430 words this week")
 */
const getWeeklyWordCountMessage = (wordCount = 0) => {
  if (wordCount === 0) {
    return "Let's start writing! Create a new project or continue an existing one";
  }
  const formattedCount = wordCount.toLocaleString();
  return `You've written ${formattedCount} word${wordCount !== 1 ? 's' : ''} this week`;
};

export default getWeeklyWordCountMessage;
